import Splide from '@splidejs/splide';

( function( app ) {
  const mq = typeof window !== 'undefined' ? window.matchMedia( `(max-width: 767px)` ) : null;

  function mountRotator( element ) {
    const splide = new Splide( element, {
      type: 'loop',
      direction: 'ttb',
      height: '3.5em',
      perPage: 1,
      perMove: 1,
      autoplay: true,
      interval: 3000,
      arrows: false,
      pagination: false,
      drag: false,
      speed: 400,
    } );
    splide.mount();
    return splide;
  }

  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
      if ( !mq ) return;
      const rotators = document.querySelectorAll( '.question-cta__rotator[data-component="question-cta-splide"]' );
      const instances = [];

      function start() {
        rotators.forEach( function( el ) {
          if ( el.__splide ) return;
          const splide = mountRotator( el );
          el.__splide = splide;
          instances.push( {el, splide} );
        } );
      }
      function stop() {
        instances.forEach( function( {el, splide} ) {
          splide.destroy();
          el.__splide = null;
        } );
        instances.length = 0;
      }

      if ( mq.matches ) start();
      mq.addEventListener( 'change', function( e ) {
        stop();
        if ( e.matches ) start();
      } );
    },
  };

  app.registerComponent( 'question-cta', COMPONENT );
} )( app );
